module.exports = __webpack_public_path__ + "static/media/stillberatung.9306eba4.jpg";